// src/pages/exercise/components/Character/CharacterVisuals.jsx

import React, { useMemo } from 'react';
import { useGLTF } from '@react-three/drei';
import { SkeletonUtils } from 'three-stdlib';

const MODELS = [
  '/assets/models/character/moose.glb',
  '/assets/models/character/bunny.glb',
  '/assets/models/character/sloth.glb',
  '/assets/models/character/tiger.glb',
];

// Scale configuration per character
const SCALES = [
  1.25,  // Moose (Index 0)
  1.0,  // Bunny (Index 1)
  1.0,  // Sloth (Index 2)
  0.85   // Tiger (Index 3)
];

// Rotation configuration per character [x, y, z] in radians
const ROTATIONS = [
  [0, 0, -0.1],  // Moose (Index 0)
  [0, 0, -0.1],  // Bunny (Index 1)
  [0, 0, -0.1],  // Sloth (Index 2)
  [0, 0, -0.1]   // Tiger (Index 3)
];

export function CharacterVisuals({ activeIndex }) {
  return (
    <>
      {MODELS.map((url, index) => (
        <CharacterModel
          key={url}
          url={url}
          isVisible={index === activeIndex}
          scale={SCALES[index]}
          rotation={ROTATIONS[index]}
        />
      ))}
    </>
  );
}

function CharacterModel({ url, isVisible, scale, rotation }) {
  const gltf = useGLTF(url);

  const clone = useMemo(
    () => (gltf?.scene ? SkeletonUtils.clone(gltf.scene) : null),
    [gltf]
  );

  if (!clone) return null;

  return <primitive object={clone} visible={isVisible} scale={scale} rotation={rotation} />;
}

MODELS.forEach((url) => useGLTF.preload(url));
